import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useStatusReport(data, options, key = "Status") {
  const axiosPrivate = useAxiosPrivate();

  const getStatusReport = async () => {
    const events = await axiosPrivate({
      method: "POST",
      url: "/Reports/Status",
      data,
      timeout: 300000, // 5 minutes in milliseconds
    }).then((res) => res.data);
    return events;
  };

  return useQuery([key, data], () => getStatusReport(data), {
    ...options,
  });
}

export default useStatusReport;
